import { createSlice, PayloadAction, SliceCaseReducers } from '@reduxjs/toolkit';
import { IAccount } from 'src/types';

const accountSlice = createSlice<IAccount | null, SliceCaseReducers<IAccount | null>>({
  name: 'account',
  initialState: null,
  reducers: {
    setAccount: (state, { payload }: PayloadAction<IAccount | null>) => {
      // if (state) {
      //   return {
      //     ...state,
      //     ...payload,
      //   };
      // }
      return payload;
    },
  },
});

export const { setAccount } = accountSlice.actions;

export default accountSlice.reducer;
